import { render } from "./RezepteEingefrorenView.vue?vue&type=template&id=7dd26142"
import script from "./RezepteEingefrorenView.vue?vue&type=script&lang=js"
export * from "./RezepteEingefrorenView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__